import lessonApi from '@/api/lesson';

const state = {
    isLoading: false,
    validationErrors: null,
    isSubmitting: false,
    lesson:null,
    lessonUpdated:null,
    lessonCreated:null,
    lessonCanceled:null,
    service:null,
    specialist:null,
    position:null,
    room:null,
    reason:null,
    cancelReason:null,
    sale:null,
    specialistGroup:null
}

export const mutationTypes = {
    getLessonInfoStart: '[lesson] Get lesson info start',
    getLessonInfoSuccess: '[lesson] Get lesson info success',
    getLessonInfoFailure: '[lesson] Get lesson info failure',

    getServiceInfoStart: '[lesson] Get service info start',
    getServiceInfoSuccess: '[lesson] Get service info success',
    getServiceInfoFailure: '[lesson] Get service info failure',

    getSpecialistListStart: '[specialist] Get specialist list start',
    getSpecialistListSuccess: '[specialist] Get specialist list success',
    getSpecialistListFailure: '[specialist] Get specialist list failure',

    getPositionListStart: '[position] Get position list start',
    getPositionListSuccess: '[position] Get position list success',
    getPositionListFailure: '[position] Get position list failure',

    getRoomListStart: '[room] Get room list start',
    getRoomListSuccess: '[room] Get room list success',
    getRoomListFailure: '[room] Get room list failure',

    getReasonListStart: '[reason] Get reason list start',
    getReasonListSuccess: '[reason] Get reason list success',
    getReasonListFailure: '[reason] Get reason list failure',

    getCancelReasonListStart: '[cancelReason] Get cancel reason list start',
    getCancelReasonListSuccess: '[cancelReason] Get cancel reason list success',
    getCancelReasonListFailure: '[cancelReason] Get cancel reason list failure',

    updateLessonStart: '[lesson] Update lesson start',
    updateLessonSuccess: '[lesson] Update lesson success',
    updateLessonFailure: '[lesson] Update lesson failure',

    createLessonStart: '[lesson] Create lesson start',
    createLessonSuccess: '[lesson] Create lesson success',
    createLessonFailure: '[lesson] Create lesson failure',

    cancelLessonStart: '[lesson] Cancel lesson start',
    cancelLessonSuccess: '[lesson] Cancel lesson success',
    cancelLessonFailure: '[lesson] Cancel lesson failure',

    getGroupSpecialistListStart: '[specialistGroup] Get group specialist list start',
    getGroupSpecialistListSuccess: '[specialistGroup] Get group specialist list success',
    getGroupSpecialistListFailure: '[specialistGroup] Get group specialist list failure',
}

export const lessonActionTypes = {
    getSchedule: '[schedule] Get schedule',
    getLessonInfo: '[lesson] Get lesson info',
    getServiceInfo: '[lesson] Get service info',
    getSpecialistList: '[specialist] Get specialist list',
    getPositionList: '[position] Get position list',
    getRoomList: '[room] Get room list',
    getReasonList: '[reason] Get reason list',
    getCancelReasonList: '[cancelReason] Get cancel reason list',
    updateLesson: '[lesson] Update lesson',
    createLesson: '[lesson] Create lesson',
    cancelLesson: '[lesson] Cancel lesson',
    getGroupSpecialistList: '[specialistGroup] Get group specialist list'

}

const mutations = {
    [mutationTypes.getLessonInfoStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getLessonInfoSuccess](state, payload) {
        state.isLoading = false
        state.lesson = payload
        state.validationErrors = null
    },
    [mutationTypes.getLessonInfoFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getServiceInfoStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getServiceInfoSuccess](state, payload) {
        state.isLoading = false
        state.service = payload
        state.validationErrors = null
    },
    [mutationTypes.getServiceInfoFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getSpecialistListStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getSpecialistListSuccess](state, payload) {
        state.isLoading = false
        state.specialist = payload
        state.validationErrors = null
    },
    [mutationTypes.getSpecialistListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getPositionListStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getPositionListSuccess](state, payload) {
        state.isLoading = false
        state.position = payload
        state.validationErrors = null
    },
    [mutationTypes.getPositionListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getRoomListStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getRoomListSuccess](state, payload) {
        state.isLoading = false
        state.room = payload
        state.validationErrors = null
    },
    [mutationTypes.getRoomListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getReasonListStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getReasonListSuccess](state, payload) {
        state.isLoading = false
        state.reason = payload
        state.validationErrors = null
    },
    [mutationTypes.getReasonListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getCancelReasonListStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getCancelReasonListSuccess](state, payload) {
        state.isLoading = false
        state.cancelReason = payload
        state.validationErrors = null
    },
    [mutationTypes.getCancelReasonListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.updateLessonStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.updateLessonSuccess](state, payload) {
        state.isLoading = false
        state.lessonUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.updateLessonFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.createLessonStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.createLessonSuccess](state, payload) {
        state.isLoading = false
        state.lessonCreated = payload
        state.validationErrors = null
    },
    [mutationTypes.createLessonFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.cancelLessonStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.cancelLessonSuccess](state, payload) {
        state.isLoading = false
        state.lessonCanceled = payload
        state.validationErrors = null
    },
    [mutationTypes.cancelLessonFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getGroupSpecialistListStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getGroupSpecialistListSuccess](state, payload2) {
        state.isLoading = false
        state.specialistGroup = payload2
        state.validationErrors = null
    },
    [mutationTypes.getGroupSpecialistListFailure](state,payload2) {
        state.isLoading = false
        state.validationErrors = payload2
    },
}

const actions = {
    [lessonActionTypes.getLessonInfo](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getLessonInfoStart)
            lessonApi
                .getLessonInfo(data)
                .then(response => {
                    context.commit(mutationTypes.getLessonInfoSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getLessonInfoFailure,response)
                })
        })
    },
    [lessonActionTypes.getServiceInfo](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getServiceInfoStart)
            lessonApi
                .getServiceInfo(data)
                .then(response => {
                    context.commit(mutationTypes.getServiceInfoSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getServiceInfoFailure,response)
                })
        })
    },
    [lessonActionTypes.getSpecialistList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getSpecialistListStart)
            lessonApi
                .getSpecialistList(data)
                .then(response => {
                    context.commit(mutationTypes.getSpecialistListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getSpecialistListFailure,response)
                })
        })
    },
    [lessonActionTypes.getPositionList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getPositionListStart)
            lessonApi
                .getPositionList(data)
                .then(response => {
                    context.commit(mutationTypes.getPositionListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getPositionListFailure,response)
                })
        })
    },
    [lessonActionTypes.getRoomList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getRoomListStart)
            lessonApi
                .getRoomList(data)
                .then(response => {
                    context.commit(mutationTypes.getRoomListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getRoomListFailure,response)
                })
        })
    },
    [lessonActionTypes.getReasonList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getReasonListStart)
            lessonApi
                .getReasonList(data)
                .then(response => {
                    context.commit(mutationTypes.getReasonListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getReasonListFailure,response)
                })
        })
    },
    [lessonActionTypes.getCancelReasonList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getCancelReasonListStart)
            lessonApi
                .getCancelReasonList(data)
                .then(response => {
                    context.commit(mutationTypes.getCancelReasonListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getCancelReasonListFailure,response)
                })
        })
    },
    [lessonActionTypes.updateLesson](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.updateLessonStart)
            lessonApi
                .updateLesson(data)
                .then(response => {
                    context.commit(mutationTypes.updateLessonSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.updateLessonFailure,response)
                })
        })
    },
    [lessonActionTypes.createLesson](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createLessonStart)
            lessonApi
                .createLesson(data)
                .then(response => {
                    context.commit(mutationTypes.createLessonSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createLessonFailure,response)
                })
        })
    },
    [lessonActionTypes.cancelLesson](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.cancelLessonStart)
            lessonApi
                .cancelLesson(data)
                .then(response => {
                    context.commit(mutationTypes.cancelLessonSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.cancelLessonFailure,response)
                })
        })
    },
    [lessonActionTypes.getGroupSpecialistList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getGroupSpecialistListStart)
            lessonApi
                .getGroupSpecialistList(data)
                .then(response => {
                    context.commit(mutationTypes.getGroupSpecialistListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getGroupSpecialistListFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}